import React, { useEffect, useState } from "react";
import { Field } from "redux-form";
import { renderTextField, renderTextFieldPreValue } from "../formcomponents";
import { Table, Button, Grid } from "semantic-ui-react";
const ContactFieldArr = ({
  fields,

  meta: { touched, error, submitFailed },
}) => {
  useEffect(() => {
    console.group("scbiusbcscs", fields);
    // Check if there is at least one field already present
    if (fields.length < 1) {
      fields.push(); // Only push an empty field if none exist
    }
  }, [fields]);

  return (
    <div>
      {fields.map((item, index) => (
        <div key={index}>
          <Grid.Row key={index}>
            <Grid columns="four">
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name={`${item}.contacName`}
                    type="text"
                    label="Contact Name"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={`${item}.contactNumber`}
                    type="number"
                    label="Contact Number"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={`${item}.contactEmail`}
                    type="email"
                    label="Contact Email"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <br />
                  {index != 0 && (
                    <Button
                      type="button"
                      floated="left"
                      negative
                      onClick={() => fields.remove(index)}
                    >
                      X
                    </Button>
                  )}

                  {fields.length - 1 === index && (
                    <Button
                      type="button"
                      positive
                      floated="left"
                      onClick={() => fields.push({})}
                    >
                      Add More
                    </Button>
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>
        </div>
      ))}
      <br />
    </div>
  );
};

export default ContactFieldArr;
